
import { getRecentCampsiteDetailsService } from '../../../apps/recent-campsites/RecentCampsiteDetailsService'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { RecentCampsiteDetails } from '../../../apps/recent-campsites/types'

@Component
export default class AppMenuRecentCampsites extends Vue {
  @Prop({ default: 6 })
    limit: number

  recentCampsites: RecentCampsiteDetails[] = []

  mounted() {
    getRecentCampsiteDetailsService()
      .getAll(this.$route.params.lang || 'en-gb', { limit: this.limit })
      .then((recentCampsites) => {
        this.recentCampsites = recentCampsites
      })
  }

  getRecentImageUrl(campsite: RecentCampsiteDetails): string {
    return campsite.primaryPhoto ? campsite.primaryPhoto.url : ''
  }
}
